<template>
    <div class="w-full focus-within:ring">
        <div
            class="grid grid-flow-col auto-cols-[1fr]"
            role="tablist"
            aria-label="Information about AgencyCentral and recruitment agencies"
        >
            <button
                v-for="(title, key, idx) in entries"
                class="flex-grow text-lg text-center font-bold whitespace-nowrap overflow-hidden overflow-ellipsis border border-grey-20 py-6"
                :class="headerClasses(key)"
                role="tab"
                :id="headerId(key)"
                :ref="headerId(key)"
                :aria-selected="key === activeKey"
                :aria-controls="regionId(key)"
                :tabindex="
                    key === activeKey
                    ? 0
                    : [undefined, null, ''].includes(activeKey) && idx === 0
                    ? 0
                    : -1
                "
                @click="setActiveKey(key)"
                @keyup.enter="setActiveKey(key)"
                @keyup.space.once="setActiveKey(key)"
                @keyup.right="setFocusIdx(idx+1)"
                @keyup.left="setFocusIdx(idx-1)"
            >
                {{ title }}
            </button>
        </div>
        <article
            v-for="(title, key) in entries"
            class="border border-t-0 border-grey-20 p-4"
            :class="bodyClasses(key)"
            role="tabpanel"
            tabindex="0"
            :aria-labelledby="headerId(key)"
            :id="regionId(key)"
        >
            <slot :name="`body-${key}`"/>
        </article>
    </div>
</template>

<script>
import selectableSlot from "Mixins/selectableSlot";
import uuid from "Mixins/uuid";

export default {
    name: "TabbedCard",
    mixins: [selectableSlot, uuid],
    props: {},
    data() {
        return {};
    },
    methods: {
        regionId(key) {
            return `${this.uuid}-${key}-region`;
        },
        headerId(key) {
            return `${this.uuid}-${key}-header`;
        },
        headerClasses(key) {
            const activeClasses = [
                'text-blue',
                'border-b-0',
            ];
            const inactiveClasses = [
                'text-blue-30',
                'cursor-pointer',
                'bg-grey-10',
            ];
            return (key === this.activeKey) ? activeClasses : inactiveClasses;
        },
        bodyClasses(key) {
            return {
                'hidden': key !== this.activeKey,
                'block': key === this.activeKey,
            };
        },
        setFocusIdx(idx) {
            const availableKeys = Object.keys(this.entries);
            if (availableKeys.length === 0) {
                return;
            }

            let focusKey;
            if (idx === availableKeys.length) {
                focusKey = availableKeys[0];
            } else if (idx === -1) {
                focusKey = availableKeys[availableKeys.length - 1];
            } else {
                focusKey = availableKeys[idx];
            }
            const focusKeyRef = this.headerId(focusKey);
            this.$refs[focusKeyRef][0].focus();
        }
    }
}
</script>
